






















































































































import { Component, Vue, Prop } from "vue-property-decorator";
import ajax from "@/lib/ajax";

@Component({})
export default class AddFlightRouteXML extends Vue {
  @Prop() editItem!: any;
  @Prop() serviceNames!: string[];

  isValid: boolean = false;
  dialog: boolean = true;
  isEdit: boolean = false;
  route: any = {
    id: null,
    origin: "",
    destination: "",
    serviceName: "",
    url: "",
  };

  data() {
    return {
      rules: {
        required: (value) => !!value || "Zorunlu Alan.",
      },
    };
  }

  created() {
    if (this.editItem) {
      this.isEdit = true;
      this.route = { ...this.editItem };
    } else {
      this.isEdit = false;
    }
  }

  formatOrigin() {
    if (!this.route.origin) return;
    this.route.origin = this.route.origin
      .toUpperCase()
      .replace(/[^A-Z]/g, "")
      .substring(0, 3);
  }

  formatDestination() {
    if (!this.route.destination) return;
    this.route.destination = this.route.destination
      .toUpperCase()
      .replace(/[^A-Z]/g, "")
      .substring(0, 3);
  }

  async saveRoute() {
    try {
      const response = await ajax.post(
        "/api/services/app/Admin/SaveFlightXmlRoute",
        this.route
      );

      if (response.data.success) {
        if (this.isEdit) {
          Vue.$toast.success("Kayıt Güncellendi");
        } else {
          Vue.$toast.success("Kayıt Eklendi");
        }
        this.closeDialog();
      }
    } catch (error) {
      console.error("Kayıt sırasında hata oluştu:", error);
    }
  }

  closeDialog() {
    this.$emit("closed");
  }

  cancelDialog() {
    this.$emit("cancel");
  }
}
